export interface IRequestReviewValidation {
  requestReviewId: string;
  canSubmit: boolean;
  recomendedResults: string[];
  message: string;
  shouldCalate: boolean;
}

export class IRequestReviewValidationForm {
  requestId: string = "";

  constructor(requestId?: string) {
    if (requestId) {
      this.requestId = requestId;
    }
    Object.assign(this);
  }
}
